import React from 'react';
import { string, node } from 'prop-types';
import classnames from 'classnames';
import { useBQ } from '../../hooks/useBQ';
import { sendMixpanelWidgetClickEvent } from '../../utils/mixpanel';
import { TrackingLink } from '../TrackingLink';

import styles from './styles.module.scss';

export const ExploreMoreServices = (props) => {
    const { className, children, exploreSlug, affiliateId, widgetType, brand, afp, afp1, utmCampaign } = props;

    const { sendBQEvent } = useBQ();

    const clickName = 'more_button';
    const clickSection = 'explore_more';
    const hostReference = afp1;

    const onExploreClick = () => {
        sendBQEvent({
            type: 'nga.explore_more_click',
            affiliateId,
            widgetType,
            afp1,
        });
        sendMixpanelWidgetClickEvent({ affiliateId, clickName, clickSection, hostReference });
    };

    const marketingParams = {
        affiliateId,
        utmCampaign,
        brand,
        afp,
        afp1: hostReference,
        afp2: clickName,
        afp3: clickSection,
        widgetType,
    };

    return (
        <TrackingLink
            className={classnames(className, styles['service-button'])}
            onClick={onExploreClick}
            slug={exploreSlug}
            {...marketingParams}
        >
            {children}
        </TrackingLink>
    );
};

ExploreMoreServices.propTypes = {
    className: string,
    children: node,
    exploreSlug: string,
    affiliateId: string,
    widgetType: string,
    brand: string,
    afp: string,
    afp1: string,
    utmCampaign: string,
};
